import { type RouteObject } from "react-router-dom";
import { AppShell } from "./layout/AppShell.js";
import { RequireAuth } from "./layout/RequireAuth.js";
import { RequireAuthPreTotp } from "./layout/RequireAuthPreTotp.js";
import { AuthBotPage } from "./pages/AuthBotPage.js";
import { LoginPage } from "./pages/LoginPage.js";
import { NotFoundPage } from "./pages/NotFoundPage.js";
import { AccountPage } from "./pages/AccountPage.js";
import { OnboardingPage } from "./pages/OnboardingPage.js";
import { WalletPage } from "./pages/WalletPage.js";
import { ActivatePage } from "./pages/ActivatePage.js";
import { TotpSetupPage } from "./pages/TotpSetupPage.js";
import { TotpVerifyPage } from "./pages/TotpVerifyPage.js";

export const routes: RouteObject[] = [
  // Public
  {
    path: "/login",
    element: <LoginPage />,
  },
  // Public — landing for the bot's "🔑 Открыть ЛК" deeplink after
  // /start <invite_code>. Burns one-shot token → sets cookie → /
  {
    path: "/auth/bot",
    element: <AuthBotPage />,
  },

  // Pre-TOTP zone (session exists, totp_verified not required)
  {
    element: <RequireAuthPreTotp />,
    children: [
      { path: "/totp/setup",  element: <TotpSetupPage /> },
      { path: "/totp/verify", element: <TotpVerifyPage /> },
    ],
  },

  // Fully authenticated zone (redirects to /totp/verify if totp_required)
  {
    element: <RequireAuth />,
    children: [
      {
        // Shared layout (header + outlet)
        element: <AppShell />,
        children: [
          { path: "/",            element: <AccountPage /> },
          { path: "/onboarding",  element: <OnboardingPage /> },
          { path: "/wallet",      element: <WalletPage /> },
          { path: "/activate",    element: <ActivatePage /> },
        ],
      },
    ],
  },
  { path: "*", element: <NotFoundPage /> },
];
